import { create } from "@movicoders/store";
import { SnackbarService, SnackbarColor } from "./SnackbarService";

export const useSnackbar = create<SnackbarService>((set) => ({
  state: {
    isVisible: false,
  },
  hide: () => {
    set((value) => ({
      ...value,
      state: {
        ...value.state,
        isVisible: false
      }
    }))
  },
  show: (message: string, severity?: SnackbarColor) => {
    set((state) => {
      return {
        ...state,
        state: {
          isVisible: true,
          message,
          severity,
        },
      };
    });
  },
})).build();
